import _ from 'lodash'
import handlebars from 'handlebars'

const colorByType = {
  "Positive" : '#40B684',
  "Neutral" : '#F7B638',
  "Negative" : '#DF4948'
};

const imageNameByType = {
  "VeryPositive" : 'smile',
  "Positive" : 'smile',
  "Neutral" : 'meh',
  "Negative" : 'frown',
  "VeryNegative" : 'frown'
};

const ratingToSentiment = (rating) => {
  if(rating < 3) {
    return "negative"
  }
  else if(rating > 3){
    return "positive"
  }
  else {
    return "neutral"
  }
};

export const helpers = {
  include: function(source) {
    return new handlebars.SafeString(source);
  },
  ifEqual: function(param1, param2, options) {
    return param1 === param2 ? options.fn(this) : ""
  },
  ifGreaterThan: function(param1, param2, options) {
    return param1 > param2 ? options.fn(this) : ""
  },
  containsKeyValuePair: function(list,key,value,options) {
    return list && list.find( item => (item[key] === value)) ?  options.fn(this) : ""
  },
  doesNotContainKeyValuePair: function(list,key,value,options) {
    return !list || (list && list.find( item => (item[key] !== value))) ?  "" : options.fn(this)
  },
  pluralize: function(singular,plural,length) {
    return (length === 1 || length === -1) ? singular : plural
  },
  reviewsForType: function(reviewsByType,type) {
    return _.findWhere(reviewsByType,{type})
  },
  colorForType: function(type) {
    return colorByType[type]
  },
  providerIcon: function(provider) {
    let defaultIcon = "https://s3.amazonaws.com/content-provider-logos/default.png"
    return provider ? `https://s3.amazonaws.com/content-provider-logos/${provider.toLowerCase()}.png` : defaultIcon
  },
  reviewsBySentiment: function(reviews, options) {
    let positive = [];
    let negative = [];
    let neutral = [];

    (reviews || []).forEach(review => {
      if (review.rating >= 4 || review.nps >= 9 || review.recommended) positive.push(review)
      else if (review.rating < 3 || review.nps < 7 || review.recommended === false) negative.push(review)
      else neutral.push(review)
    });

    let output = "";
    if (positive) {
      output += options.fn({reviews: positive, sentiment: "Positive"})
    }
    if (neutral) {
      output += options.fn({reviews: neutral, sentiment: "Neutral"})
    }
    if (negative) {
      output += options.fn({reviews: negative, sentiment: "Negative"})
    }

    return output
  },
  recommendation: function (recommendation, recommendedText) {
    let recommendationIcon = `\n<img src="https://s3.amazonaws.com/email-alerts-graphics/v2/recommendation-${recommendation}.png" alt="" style="margin-right: 1px; max-height:20px; margin-bottom: -3px;"/>`;
    let recommendationTextBlock = '\n<span style=" padding-left: 5px; padding-right: 5px; font-size: 16px; font-weight: 500; color: #7E8890; ">' + recommendedText + '</span>';
    return new handlebars.SafeString(`<div class="stars" style="float: left; margin-left:10px; width:200px; text-align: left;">${recommendationIcon + recommendationTextBlock}</div>`);
  },
  stars: function(rating) {
    let valueStars = _.range(1,Math.round(rating) + 1).reduce((string,value) => {
      return string + `\n<img src="https://s3.amazonaws.com/email-alerts-graphics/v2/star-${ratingToSentiment(rating)}.png" alt="" style="margin-right: 1px;"/>`
    },"");
    let greyStars = rating < 5 ? _.range(Math.round(rating)+1,6).reduce( string => {
      return string + `\n<img src=https://s3.amazonaws.com/email-alerts-graphics/v2/star-grey.png alt="" style="margin-right: 1px;"/>`
    },"") : '';
    return new handlebars.SafeString(`<div class="stars" style="float: left; margin-left:10px; width:140px; text-align: left;">${valueStars + greyStars}</div>`)
  },
  date: (dateInput) => {
    let formattedDate = typeof dateInput === "number" ? moment(dateInput).format('MM/DD/YYYY') : moment(dateInput,'YYYY-MM-DD').format('MM/DD/YYYY')
    return formattedDate.charAt(0) === '0' ? formattedDate.substring(1) : formattedDate
  },
  capitalizeFirstLetter: (input) => {
    return input.charAt(0).toUpperCase() + input.substring(1).toLowerCase()
  },
  sentimentIcon: (classification) => {
    let sentimentIcon =
      `<span class="sentiment-icon ${classification}" style="color: ${colorByType[classification]};margin: 6px 22px 15px 22px;text-align: center">
      <img width="31" height="30" src="https://s3.amazonaws.com/email-alerts-graphics/v2/${imageNameByType[classification]}.png"/>
    </span>`;
    return new handlebars.SafeString(sentimentIcon)
  },
  segmentWithHighlightedTopics: (segment,topics) => {
    return `${segment}` //TODO: WRAP TOPIC MATCHES IN CLASSED SPANS
  },
  relativeFrequencyBar: (array,frequency,index) => {
    let topFrequency = array.reduce((acc,item) => (item.frequency > acc ? item.frequency : acc),0)
    let colors = ['#F9A914','#2AA8B4','#607791'];
    let colorIndex = index > colors.length - 1 ? index % (colors.length - 1) : index;
    return new handlebars.SafeString(`<div style="height:10px;border-radius:3px;background-color:${colors[colorIndex]};width:${Math.round(topFrequency > 0 ? 100*frequency/topFrequency : 0)}%"`)
  },
  formatNumber: (number, precision) => number ? number.toLocaleString({maximumFractionDigits: precision}) : '',
  formatDelta: (delta, precision, inverted = false) => {
    if (typeof delta === "undefined") {
      return ""
    }

    const num = delta.toLocaleString({maximumFractionDigits: precision});
    const sign = delta >= 0 ? '+' : '';

    if (delta * (inverted === true ? -1 : 1) > 0) {
      return new handlebars.SafeString(`<span class="delta-up" style="color: green;">${sign}${num}</span>`)
    } else if (delta === 0) {
      return num
    } else {
      return new handlebars.SafeString(`<span class="delta-down" style="color: red;">${sign}${num}</span>`)
    }
  },
  locationAddressSummary: (location) => {
    const addr = location.businessAddress || {};
    return addr.street + (addr.suite ? ' ' + addr.suite : '') +
      (addr.city ? `, ${addr.city}` : '') + (addr.state ? `, ${addr.state}` : '') + (addr.postalCode ? ` ${addr.postalCode}` : '')
  }
};

export function registerHelpers(handlebars) {
  _.forOwn(helpers, (value, key) => {
    handlebars.registerHelper(key, value)
  })
};
